'use client'

import CrossIcon from '@/assets/icons/leaderboard/lb-cross-16.svg'
import SearchIcon from '@/assets/icons/leaderboard/lb-search-20.svg'

import S from './LeaderboardSearch.module.scss'

type LeaderboardSearchProps = {
  value: string
  onChange: (value: string) => void
  placeholder: string
  clearLabel: string
}

export function LeaderboardSearch({
  value,
  onChange,
  placeholder,
  clearLabel
}: LeaderboardSearchProps) {
  return (
    <label className={S.search}>
      <SearchIcon className={S.icon} aria-hidden />
      <input
        type="search"
        className={S.input}
        value={value}
        placeholder={placeholder}
        aria-label={placeholder}
        maxLength={128}
        onChange={event => onChange(event.target.value)}
      />
      {value ? (
        <button
          type="button"
          className={S.clear}
          aria-label={clearLabel}
          onClick={() => onChange('')}
        >
          <CrossIcon className={S.clearIcon} aria-hidden />
        </button>
      ) : null}
    </label>
  )
}
